export default {
  lang: {
    zh: '中文',
    en: 'English',
    lo: 'ລາວ',
    th: 'ไทย',
    select: '选择语言',
  },
  nav: {
    home: '首页',
    services: '服务',
    projects: '项目',
    news: '新闻',
    contact: '联系',
    bookNow: '立即预约',
    menu: '菜单',
  },
  footer: {
    tagline: '专业可靠的业务咨询与项目服务，助力企业数字化升级。',
    quickLinks: '快速链接',
    services: '服务项目',
    projects: '项目案例',
    news: '最新动态',
    contact: '联系我们',
    contactInfo: '联系方式',
    email: '邮箱',
    phone: '电话',
    workHours: '工作时间',
    copyright: '© {year} 万运堂. 保留所有权利.',
  },
  brand: {
    name: '万运堂',
    subtitle: '业务咨询 · 项目服务',
  },
  common: {
    loading: '加载中...',
    empty: '暂无数据',
    latest: '最新',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    refresh: '刷新数据',
    refreshing: '刷新中...',
    readMore: '阅读全文 →',
    backToList: '← 返回新闻列表',
    backToNews: '返回列表',
  },
  home: {
    badge: '专业 · 可靠 · 高效',
    title: '助力企业数字化升级与业务增长',
    desc: '万运堂提供企业官网建设、电商平台与产品展示等一站式项目服务，从咨询到交付全程陪伴。',
    bookNow: '立即预约',
    learnServices: '了解服务',
    statProjects: '成功项目',
    statSatisfaction: '客户满意度',
    statSupport: '技术支持',
    servicesTitle: '我们的服务',
    servicesSubtitle: '覆盖从品牌展示到商业转化的完整数字化需求',
    viewAllServices: '查看全部服务 →',
    projectsTitle: '热门项目',
    projectsSubtitle: '选择适合您的项目类型，一键预约咨询',
    newsTitle: '最新动态',
    newsSubtitle: '了解万运堂的最新资讯与行业洞察',
    ctaTitle: '准备好开始您的项目了吗？',
    ctaDesc: '填写预约表单，我们的顾问将在 24 小时内与您联系。',
    ctaBtn: '免费预约咨询',
    service1Title: '企业官网',
    service1Desc: '响应式设计，SEO 优化，提升品牌形象。',
    service2Title: '电商平台',
    service2Desc: '商品管理、订单支付、会员体系一应俱全。',
    service3Title: '产品展示',
    service3Desc: '精美视觉呈现，突出产品核心卖点。',
  },
  services: {
    title: '服务项目',
    subtitle: '我们提供全方位的数字化解决方案，助力您的业务腾飞',
    bookConsult: '预约咨询',
    s1Title: '企业官网建设',
    s1Desc: '打造专业、现代的企业形象网站，提升品牌可信度与线上获客能力。',
    s1f1: '响应式多端适配',
    s1f2: 'SEO 搜索引擎优化',
    s1f3: 'CMS 内容管理系统',
    s1f4: '高性能与安全加固',
    s2Title: '电商平台开发',
    s2Desc: '构建功能完善的在线商城，支持商品管理、订单处理与支付集成。',
    s2f1: '商品与库存管理',
    s2f2: '购物车与订单系统',
    s2f3: '支付与物流对接',
    s2f4: '会员与营销工具',
    s3Title: '产品展示站',
    s3Desc: '以精美视觉呈现产品核心价值，吸引潜在客户并促进转化。',
    s3f1: '视觉设计与动效',
    s3f2: '产品详情页优化',
    s3f3: '多媒体内容支持',
    s3f4: '数据分析与追踪',
    s4Title: '业务咨询',
    s4Desc: '从需求分析到技术选型，提供专业的数字化转型咨询服务。',
    s4f1: '需求调研与分析',
    s4f2: '技术方案设计',
    s4f3: '项目规划与排期',
    s4f4: '持续运维支持',
  },
  projects: {
    title: '项目案例',
    subtitle: '浏览我们的项目类型，选择适合您的方案并立即预约',
    empty: '暂无项目',
    bookProject: '预约此项目',
  },
  projectItems: {
    building: {
      name: '企业官网',
      desc: '响应式企业网站建设，提升品牌形象与线上获客能力。',
    },
    cart: {
      name: '电商平台',
      desc: '全功能商城系统，支持商品管理、订单与支付集成。',
    },
    sparkle: {
      name: '产品展示',
      desc: '精美产品展示站，突出核心卖点与视觉体验。',
    },
  },
  news: {
    title: '最新动态',
    subtitle: '行业资讯与公司新闻',
    empty: '暂无新闻，敬请期待。',
    notFound: '新闻不存在或已被删除。',
  },
  contact: {
    title: '联系我们',
    subtitle: '欢迎通过以下方式与我们取得联系，或直接在项目页提交预约',
    emailLabel: '电子邮箱',
    phoneLabel: '客服热线',
    hoursLabel: '工作时间',
    addressLabel: '公司地址',
    bookOnline: '在线预约',
    formTitle: '快速留言',
    formDesc: '填写以下信息，我们会尽快回复您。',
    name: '姓名',
    namePh: '您的姓名',
    email: '邮箱',
    emailPh: "name{'@'}example.com",
    address: '留言地址',
    addressPh: '请填写您的地址（选填）',
    message: '留言',
    messagePh: '请描述您的需求',
    submit: '发送留言',
    fillRequired: '请填写姓名和邮箱',
    submitSuccess: '留言已收到，我们会尽快与您联系！',
    submitFail: '提交失败，请稍后重试',
    defaultEmail: "contact{'@'}wanyuntang.com",
    defaultPhone: '400-888-0000',
    defaultAddress: '中国 · 业务咨询服务中心',
    defaultWorkHours: '周一至周五 9:00 – 18:00',
  },
  appointment: {
    title: '项目预约',
    close: '关闭',
    name: '姓名',
    namePh: '请输入您的姓名',
    nameErr: '请输入至少 2 个字的姓名',
    email: '邮箱',
    emailErr: '请输入有效的邮箱地址',
    phone: '手机号',
    phonePh: '选填，便于我们联系您',
    date: '预约日期',
    dateErr: '请选择预约日期',
    slot: '预约时段',
    slotPh: '请选择时段',
    slotErr: '请选择预约时段',
    address: '地址',
    addressPh: '选填，支持地址自动完成',
    note: '备注',
    notePh: '请描述您的需求或问题',
    submitting: '提交中...',
    submit: '确认预约',
    success: '预约已提交，我们会尽快与您联系！',
    fail: '提交失败，请稍后重试',
    datePh: '请选择日期',
    yearPh: '年',
    monthPh: '月',
    dayPh: '日',
    slot1: '09:00–10:00',
    slot2: '10:00–11:00',
    slot3: '11:00–12:00',
    slot4: '14:00–15:00',
    slot5: '15:00–16:00',
    slot6: '16:00–17:00',
  },
  admin: {
    title: '管理后台',
    subtitle: '万运堂官网内容管理系统',
    username: '用户名',
    usernamePh: '请输入管理员用户名',
    password: '密码',
    passwordPh: '请输入密码',
    showPwd: '显示',
    hidePwd: '隐藏',
    remember: '记住用户名',
    login: '登录后台',
    loggingIn: '登录中...',
    loggedIn: '已登录 · {user}',
    logout: '退出登录',
    loginSuccess: '登录成功',
    loginFail: '登录失败，请检查用户名和密码',
    fillCredentials: '请填写用户名和密码',
    sessionExpired: '登录已过期，请重新登录',
    loadFail: '加载数据失败',
    appointments: '预约管理',
    noAppointments: '暂无预约记录',
    colName: '姓名',
    colContact: '邮箱 / 电话',
    colProject: '项目',
    colTime: '时间',
    colStatus: '状态',
    colAction: '操作',
    confirmBtn: '确认',
    cancelBtn: '取消',
    statusPending: '待确认',
    statusConfirmed: '已确认',
    statusCancelled: '已取消',
    statusUpdated: '状态已更新',
    updateFail: '更新失败',
    messages: '留言管理',
    noMessages: '暂无留言',
    colAddress: '留言地址',
    colMessage: '留言内容',
    colCreated: '提交时间',
    markRead: '标为已读',
    markUnread: '标为未读',
    statusUnread: '未读',
    statusRead: '已读',
    contactSettings: '联系地址设置',
    contactSettingsDesc: '以下信息将显示在官网联系页面',
    saveContact: '保存联系信息',
    contactSaved: '联系信息已保存',
    publishNews: '发布新闻',
    editNews: '编辑新闻',
    newsTitle: '标题',
    newsSummary: '摘要',
    newsContent: '正文内容',
    newsDate: '发布时间（如 2026-07-03）',
    publish: '发布',
    saveEdit: '保存修改',
    cancelEdit: '取消编辑',
    existingNews: '已有新闻',
    noNews: '暂无新闻',
    edit: '编辑',
    fillNews: '请填写标题和正文',
    newsPublished: '新闻已发布',
    newsUpdated: '新闻已更新',
    opFail: '操作失败',
  },
}
